export default function Equipment() {
  const equipment = [
    {
      icon: 'ri-links-line',
      title: 'Канатные тельферы',
      description: 'Грузоподъёмность до 10 тонн, высота подъёма до 30 метров'
    },
    {
      icon: 'ri-arrow-left-right-line',
      title: 'Передвижные',
      description: 'С электрической тележкой для перемещения по балке'
    },
    {
      icon: 'ri-arrow-down-line',
      title: 'С пониженной строительной высотой',
      description: 'Для помещений с ограниченной высотой потолков'
    }
  ];

  return (
    <section id="equipment" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-10">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-8 sm:mb-10 lg:mb-12">Оборудование</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {equipment.map((item, index) => (
            <div 
              key={index}
              className="border border-gray-200 p-6 sm:p-8 hover:border-[#1A2B4A] transition-colors group cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${item.icon} text-[#1A2B4A] text-5xl`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed mb-6 line-clamp-2">
                {item.description}
              </p>
              <a href="#" className="text-sm text-[#1A2B4A] hover:underline inline-flex items-center gap-1 cursor-pointer">
                Подробнее <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}